<template>
  <div>
    <el-card>
      <!-- 头部 -->
      <el-row :gutter="24">
        <el-col :span="8">
          <div style="font-size: 30px">
            企业监测报表&nbsp;&nbsp;&nbsp;
            <span style="font-size: 26px">{{ time }}</span>
          </div>
        </el-col>
      </el-row>
      <!-- echarts -->
      <el-row :gutter="24">
        <el-col :span="12">
          <v-chart
            theme="macarons"
            style="width: 100%"
            :options="polar"
          ></v-chart>
        </el-col>
        <el-col :span="12">
          <v-chart
            theme="macarons"
            style="width: 100%"
            :options="polar2"
          ></v-chart>
        </el-col>
      </el-row>
      <!-- 表格 -->
      <el-row :gutter="24">
        <el-table
          :data="tableList"
          max-height="450px"
          height="450px"
          style="width: 100%"
        >
          <el-table-column property="name" label="公司名称"> </el-table-column>
          <el-table-column property="truth" label="实际完成总任务数">
          </el-table-column>
          <el-table-column property="target" label="总指标"> </el-table-column>
          <el-table-column property="complete" label="总体完成率">
          </el-table-column>
        </el-table>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { deteleObject } from "@/tools/tool.js";
import { EnterpriseReport } from "@/setAxios";
export default {
  data() {
    return {
      time: new Date().toLocaleString("chinese", { hour12: false }),
      polar: {},
      polar2: {},
      tableList: [],
      zhanbi: 0,
    };
  },
  created() {
    this.EnterpriseReport();
  },
  mounted() {
    setInterval(() => {
      this.time = new Date().toLocaleString("chinese", { hour12: false });
    }, 1000);
  },
  methods: {
    async EnterpriseReport() {
      let that = this;
      let res = await EnterpriseReport();
      this.tableList = res.Data;
      this.polar = {
        title: {
          text: "项目所属分析",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        series: [
          {
            name: "项目所属",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: (function () {
              let arr = [];
              that.tableList.forEach((ele) => {
                let option = {
                  value: Math.floor((ele.truth / ele.target) * 100),
                  name: ele.name,
                };
                arr.push(option);
              });
              return arr;
            })(),
          },
        ],
      };

      this.polar2 = {
        title: {
          text: "企业整体完成率",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}:{c}%",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: (function () {
            let arr = [];
            that.tableList.forEach((ele) => {
              if (ele.truth !== 0) {
                arr.push(ele.name);
              }
            });
            arr = arr.reverse();
            return arr;
          })(),
        },
        series: [
          {
            type: "bar",
            data: (function () {
              let arr = [];
              that.tableList.forEach((ele) => {
                if (ele.truth !== 0)
                  arr.push(Math.floor((ele.truth / ele.target) * 100));
              });
              arr = arr.reverse();
              return arr;
            })(),
          },
        ],
      };
    },
  },
};
</script>

<style lang="scss">
.flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
</style>